import { useMemo } from 'react';

import type {
  EditorContext,
  EditorContextActionHandlers,
} from 'flow-builder/types/context';

import { useActionNodeDrop } from '../useDrop/useDrop';
import { useActionNodeMove } from '../useMove/useMove';

type UseNodeHandlersOptions = Pick<EditorContext, 'props' | 'state'>;

export function useActionHandlers({
  props,
  state,
}: UseNodeHandlersOptions): EditorContextActionHandlers {
  const onMove = useActionNodeMove({ state });
  const onDrop = useActionNodeDrop({ props, state });

  const handlers = useMemo<EditorContextActionHandlers>(
    () => ({
      onMove,
      onDrop,
    }),
    [onMove, onDrop],
  );

  return handlers;
}
